import React from 'react';
import { trackNow } from 'shared/models/analytic';
import TimeIcon from 'images/icons/time-outline.svg?react-svg';
import LocationIcon from 'images/icons/location-outline.svg?react-svg';
import GuestsIcon from 'images/icons/guests-outline.svg?react-svg';

export default class BartenderConfirmation extends React.Component {
  componentDidMount() {
    trackNow('Booking Completed');
  }

  _date(start, end) {
    return `${start.format('MMM D, h:mm A')} - ${end.format('h:mm A')}`;
  }

  render() {
    this.date = this._date(this.props.start, this.props.end);

    return (
      <div className="bartender-main bartender-main--confirmation">
        <section className="bartender-section bartender-section--confirmation-thank-you">
          <h4 className="bartender-section__heading">Thank You For Booking</h4>
          <p className="text-light text-small">
            A Saucey concierge will contact you shortly to confirm all the
            details for your bartender booking. If you have any questions please
            contact <a href="mailto:booking@saucey.com">booking@saucey.com</a>.
          </p>
        </section>

        <section>
          <h4 className="bartender-section__heading bartender-section__heading--highlight">
            Booking Details
          </h4>
        </section>

        <section className="bartender-section bartender-section--confirmation-details">
          <div className="row middle-xs">
            <span className="col-xs-3">
              <TimeIcon width={60} height={60} />
            </span>
            <span className="col-xs text-right">{this.date}</span>
          </div>

          <hr className="light" />

          <div className="row middle-xs">
            <span className="col-xs-3">
              <LocationIcon width={60} height={60} />
            </span>
            <span className="col-xs text-right">
              <div className="row">
                <div className="col-xs">{this.props.address.address}</div>
              </div>
              <div className="row">
                <div className="col-xs">
                  {this.props.address.city}, {this.props.address.state}
                </div>
              </div>
            </span>
          </div>

          <hr className="light" />

          <div className="row middle-xs">
            <span className="col-xs-3">
              <GuestsIcon width={60} height={60} />
            </span>
            <span className="col-xs text-right">
              {this.props.guests} Guests
            </span>
          </div>
        </section>

        <hr className="light" />

        <section className="bartender-section">
          <div className="row">
            <div className="col-xs-12">
              <div className="text-light text-small">
                Please Note: Bartender does not come with alcohol or mixers. You
                can purchase those in the app or online and schedule them to be
                delivered for your event.
              </div>
            </div>
          </div>
        </section>

        <div className="bartender-submit">
          <a href="/" className="button btn-primary">
            Shop For Your Event
          </a>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/components/bartender/confirmation.js